/* globals translation */

import { closestByClassName, triggerEvent } from './functions';

export const moneyFormat = new Intl.NumberFormat('nb-NO');

const b2bSearchInit = () => {
  const searchField = document.getElementById('search-for-product');
  const searchResults = Array.from(document.querySelectorAll('.product-list-view .product-row'));
  // 0745760379835, 1238418238413
  searchField.addEventListener('keyup', () => {
    const searchValues = Array.from(searchField.value.split(','));

    searchResults.forEach((item) => {
      item.classList.add('hidden');
    });

    searchValues.forEach((searchValue) => {
      const titleHits = Array.from(document.querySelectorAll(`.product-list-view .product-row[data-title*="${searchValue.trim()}" i]`));
      const skuHits = Array.from(document.querySelectorAll(`.product-list-view .product-row[data-sku*="${searchValue.trim()}" i]`));
      const eanHits = Array.from(document.querySelectorAll(`.product-list-view .product-row[data-ean*="${searchValue.trim()}" i]`));

      Array.prototype.push.apply(titleHits, skuHits);
      Array.prototype.push.apply(titleHits, eanHits);

      if (titleHits) {
        titleHits.forEach((hit) => {
          hit.classList.remove('hidden');
        });
      }

      if (searchField.value.length === 0) {
        searchResults.forEach((item) => {
          item.classList.remove('hidden');
        });
      }
    });
  });
};


const quantityUpdater = () => {
  const productRows = Array.from(document.querySelectorAll('ul.product-list-view > li.product-row'));

  productRows.forEach((row) => {
    const quantityField = row.querySelector('input.quantity-field');
    const addToCartButton = row.querySelector('.add-product-to-cart-button');
    const priceEl = row.querySelector('.price-column .price-element');
    const tester = row.querySelector('input.tester');

    if (priceEl) {
      const { price } = priceEl.dataset;

      quantityField.addEventListener('change', (event) => {
        event.preventDefault();
        const priceOutput = row.querySelector('.woocommerce-Price-amount');
        const priceQuantityOutput = row.querySelector('.quantity-price-output');
        let newPrice = price * quantityField.value;
        newPrice = parseFloat(newPrice.toFixed(2));
        newPrice = moneyFormat.format(newPrice);

        priceQuantityOutput.innerText = quantityField.value;
        priceOutput.innerText = `${newPrice} NOK`;
      });

      addToCartButton.addEventListener('click', (event) => {
        event.preventDefault();

        const { productId } = addToCartButton.dataset;
        const payload = {
          action: 'maksimer_woocommerce_ajax_add_to_cart',
          product_id: productId,
          variation_id: '',
          quantity: quantityField.value,
          tester: tester.checked,
        };

        const existingAddedInfo = row.querySelector('.product-added-info');
        if (existingAddedInfo) {
          existingAddedInfo.remove();
        }

        addToCartButton.disabled = true;
        addToCartButton.style.opacity = 0.5;
        addToCartButton.style.pointerEvents = 'none';

        jQuery.post(translation.ajaxurl, payload, (response) => {
          triggerEvent(document.body, 'wc_fragment_refresh');
          addToCartButton.style.opacity = 1;
          addToCartButton.style.pointerEvents = 'auto';
          addToCartButton.disabled = false;

          const buttonRow = closestByClassName(addToCartButton, 'price-column');
          const addedInfo = document.createElement('div');
          addedInfo.className = 'product-added-info';
          addedInfo.style.marginTop = '10px';
          addedInfo.style.fontSize = '12px';
          addedInfo.innerText = 'Lagt til';
          buttonRow.appendChild(addedInfo);
          quantityField.value = 1;
        });
      });
    }
  });
};

if (document.body.classList.contains('page-id-2799126')) {
  quantityUpdater();
  b2bSearchInit();
}


const initOrderLineDelete = () => {
  const buttons = Array.from(document.querySelectorAll('.delete-order-row'));

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const { orderId, itemId } = button.dataset;

      document.getElementById('main-content').classList.add('wait');

      const payload = {
        action: 'maksimer_woocommerce_b2b_order_delete_order_row',
        row_id: itemId,
        order_id: orderId,
      };

      jQuery.post(translation.ajaxurl, payload, (response) => {
        window.location.reload();
      });
    });
  });
};

const initOrderAddLine = () => {
  jQuery('#optional_products').select2({
    minimumInputLength: 3,
  });

  const form = document.querySelector('.add-product-to-order');
  form.addEventListener('submit', (event) => {
    event.preventDefault();

    document.getElementById('main-content').classList.add('wait');

    const { orderId } = form.dataset;
    const productId = form.querySelector('.product_id').value;
    const qty = form.querySelector('.qty').value;

    const payload = {
      action: 'maksimer_woocommerce_b2b_order_add_product',
      product_id: productId,
      order_id: orderId,
      qty,
    };

    jQuery.post(translation.ajaxurl, payload, (response) => {
      window.location.reload();
    });
  });
};

const initOrderUpdateLineQty = () => {
  const forms = Array.from(document.querySelectorAll('.qty-order-row'));
  forms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      document.getElementById('main-content').classList.add('wait');

      const { orderId, itemId } = form.dataset;
      const qty = form.querySelector('.qty').value;

      const payload = {
        action: 'maksimer_woocommerce_b2b_order_update_qty',
        item_id: itemId,
        order_id: orderId,
        qty,
      };

      jQuery.post(translation.ajaxurl, payload, (response) => {
        window.location.reload();
      });
    });
  });
};

if (document.body.classList.contains('woocommerce-view-order') && document.body.classList.contains('is-b2b')) {
  initOrderLineDelete();
  initOrderAddLine();
  initOrderUpdateLineQty();
}
